<template>
  <div class="page-container">
   <div v-if="$store.state.currentGame.quest">
      <confirm-start v-if="$store.state.currentGame.character" />
      <choose-character v-else />
    </div>
    <choose-quest v-else />
  </div>
</template>
<script>
import ChooseQuest from '@/components/start/ChooseQuest.vue';
import ChooseCharacter from '@/components/start/ChooseCharacter.vue';
import ConfirmStart from '@/components/start/ConfirmStart.vue';

export default {
  components: {
    ChooseQuest,
    ChooseCharacter,
    ConfirmStart,
  },
};
</script>
<style lang="scss">

</style>
